import Head from 'next/head'
import {useRef, useState} from 'react'
import tg from '../services/tailwindGroups'
import helperService from '../services/helperService'
import router from 'next/router'
import Loader from '../components/Loader'
import useAuth from '../hooks/auth'
import authService from '../services/authService'
import { loginViaEmailTemplate } from '../services/emailTemplateService'

export default function Home(props) {
	const auth = useAuth(),
		[token] = useState(window.location.search?.split('?')?.[1]?.split('&')[0].replace('token=', '')),
		[showEmailForm, setShowEmailForm] = useState(false),
		emailInput = useRef(null)
		// functions

	if (token)
		authService.loginWithLink(null, token, props.alert)

	if (auth?.user?.email === props?.vars?.user?.email && props.vars?.user && props.vars?.user !== 'logged out') {
		if (props.vars?.user?.role === 'webUser') {
			if (props.vars?.user?.isValidPlan){
				router.push('/planner')
			} else  if (props.vars?.user && !props.vars?.user?.isValidPlan){
				router.push('/renew')
			} else {
				router.push('/signup')
			}
			return <Loader />
		} else {
			if (props.vars.user?.preferences?.firstPageBehavior === 'Last Page' && props.vars.user?.history?.pages?.length > 0)
				router.push(props.vars.user?.history?.pages[0].url)
			else if (props.vars.user?.preferences?.firstPageBehavior === 'Brand Health')
				router.push('/analyses/health')
			else
				router.push('/main')
		}
		return <Loader />
	}

	return (
		<div className="relative w-full h-full flex">
			<Head>
				<title>Aggie: Make Social Not Suck</title>
				<meta charSet="utf-8" />
				<meta name="viewport" content="initial-scale=1.0, width=device-width" />
				<link rel="icon" type="image/png" sizes="32x32" href="/favicon.png" />
				<meta name="msapplication-TileColor" content="#da532c" />
			</Head>
			<div style={{ backgroundImage: 'url("https://s.abcnews.com/images/US/astroworld-3-ap-er-211106_1636212332763_hpMain_16x9_1600.jpg")' }} className="absolute w-full h-[100vh] bg-cover" />
			<main className="w-[42.375rem] h-[100vh] sm:h-[44.375rem] sm:bg-black bg-[rgba(.2,.2,.2,.8)] mx-auto sm:rounded-[1rem] sm:top-[10rem] relative m-auto align-center
			p-[3.5rem] sm:p-[6rem] text-white text-center">
				<img src="/images/newLogo.png" alt="Aggie Logo" className="w-[28rem] mx-auto" />

				<p className="neulis mt-3 mb-8">Choose a Login Method Below</p>
				<div className="mainLoginButtons">
					{!showEmailForm ? (
						<>
							<button className={tg.primaryButton + 'w-full mb-5 bg-transparent border-white border '}
								onClick={() => {
									helperService.logPlusGA(
										helperService.vars.logTypes.LOGIN,
										'User selected Continue With Google login method',
										{},
										'',
										{page: 'Index Page', action: 'Continue With Google Login', interaction: 'click', interface: 'button'}
									)
									auth.loginWithGoogle(props.alert)
								}}><i className="fab fa-google" /> Continue with Google
							</button>
							<button className={tg.primaryButton + 'w-full mb-5 bg-transparent border-white border'}
								onClick={() => {
									helperService.logPlusGA(
										helperService.vars.logTypes.LOGIN,
										'User selected Continue With Microsoft login method',
										{},
										'',
										{page: 'Index Page', action: 'Continue With Microsoft Login', interaction: 'click', interface: 'button'}
									)
									auth.loginWithMicrosoft(props.alert)
								}}><i className="fab fa-microsoft" /> Continue with Microsoft
							</button>
							<button className={tg.primaryButton + 'w-full bg-transparent border-white border'}
								onClick={() => {
									helperService.logPlusGA(
										helperService.vars.logTypes.LOGIN,
										'User selected Continue With Email login method',
										{},
										'',
										{page: 'Index Page', action: 'Email With Google Login', interaction: 'click', interface: 'button'}
									)
									setShowEmailForm(true)
								}}><i className="fa fa-envelope" /> Continue with Email
							</button>
							<button onClick={() => {
								helperService.logPlusGA(
									helperService.vars.logTypes.LOGIN,
									'User selected Sign Up',
									{},
									'',
									{page: 'Index Page', action: 'Sign Up For Free', interaction: 'click', interface: 'button'}
								)
								router.push('/signup')
							}} className={tg.secondaryButton + 'bg-transparent text-aggie-yellow w-full mt-14'}>
									Sign Up for Free
							</button>
						</>
					) : (
						<>
							<input ref={emailInput} className="rounded-[2rem] py-3 px-6 w-full bg-black border border-[#2b2b2b] text-white text-center text-xl
							placeholder:text-[#2b2b2b]" placeholder="Your Email Address" />
							<button
								onClick={async () => {
									if (emailInput.current.value === '') props.alert('Please enter an email address')
									else if (
										emailInput.current.value === 'fbdev@audiencegenomics.com' ||
										emailInput.current.value === 'stephen.rains+fbdev@audiencegenomics.com' ||
										emailInput.current.value === 'tyler.esposito+charliefinklegaltest@letaggiedoit.com' ||
										emailInput.current.value === 'pr+coffee_shop@letaggiedoit.com' ||
										emailInput.current.value === 'pr+personal_trainer@letaggiedoit.com'
									) {
										const result = await helperService.awaitFetch('/api/auth', {
											action: 'link',
											token: true,
											email: emailInput.current.value,
										})
										await router.push(`${window.location.origin}?token=${result.token}`).then(() => {
											// Force a reload after navigation
											window.location.reload()
										})
									}
									else {
										const email = emailInput.current.value

										helperService.logPlusGA(
											helperService.vars.logTypes.LOGIN,
											'Send Link for Login w/ Email submission button selected',
											{},
											'',
											{page: 'Index Page', action: 'Send Link email submission button selected', interaction: 'click', interface: 'button'}
										)

										window.localStorage.setItem('emailForSignIn', email)
										const status = await helperService.awaitFetch('/api/auth', {
											action: 'magic',
											token: false,
											email
										})
										if (status?.success === false) {
											helperService.log('LOGIN_ERROR', `Login Link was rejected for ${email}`)
											props.alert('User with email ' + emailInput.current.value + ' is not registered', 'error')
										} else {
											helperService.mail(loginViaEmailTemplate(status.user.firstName),
												status.user.email,
												'Aggie Login Link'
											)
											props.alert('Login Email Sent to ' + emailInput.current.value)
										}
										setShowEmailForm(false)
									}
								}}
								className={tg.primaryButton + 'w-full mt-5  bg-transparent border-white border'}
							>SEND LINK
							</button>
							<div className="cursor-pointer text-xl uppercase mt-6" onClick={() => setShowEmailForm(false)}>Cancel</div>
						</>
					)}
				</div>
			</main>
		</div>
	)

}
